var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "panel granary-right-panel" }, [
    _c("div", { staticClass: "chart-box" }, [
      _c("div", { ref: "chart", staticClass: "chart" }),
      _c("div", { staticClass: "bg" }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }